import { ChangeDetectionStrategy, Component } from '@angular/core';
import * as FlatModels from "@medsurf/flat-models";
import * as FlatFacades from '@medsurf/flat-facades';

@Component({
    selector: 'medsurf-slide-edit',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './edit.component.html',
    styleUrls: ['./edit.component.scss'],
    standalone: false
})
export class EditComponent {
  readonly FlatModels = FlatModels;
  
  constructor(public slideAuthorFacade: FlatFacades.SlideAuthorFacade) {
  }
}
